import styled from '@emotion/styled';

const ConnectDropdownNameWrapper = styled('div')({
  display: 'inline-block',
  width: 'calc(100% - 6rem)',
});

export default ConnectDropdownNameWrapper;
